import { useState, useEffect } from "react";
import { Flex, Text, Button } from "@radix-ui/themes";
import { MenuItem } from "components";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { LinkIcon, Square3Stack3DIcon } from "@heroicons/react/24/outline";

export function IntegrationsLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  // Helper function to get menu state from path
  const getMenuStateFromPath = (path) => {
    if (path.includes("/integrations/active")) return "active";
    if (path.includes("/integrations/browse-all")) return "browse-all";
    return "active"; // default
  };

  // State to manage menu selection
  const [integrationsMenuSelection, setIntegrationsMenuSelection] = useState(
    getMenuStateFromPath(location.pathname)
  );

  const handleIntegrationsMenuSelection = (flag) => {
    setIntegrationsMenuSelection(flag);
    navigate(flag);
  };

  // Update menu selection on path change
  useEffect(() => {
    setIntegrationsMenuSelection(getMenuStateFromPath(location.pathname));
  }, [location.pathname]);

  return (
    <Flex className="integration-layout" style={{ alignSelf: "stretch" }} direction="column" align="start" gap="5"
      width="100%" height="100%">
      {/* Main content */}
      <Flex className="integration-main-content" style={{ alignSelf: "stretch", flex: "1 0 0", minHeight: 0 }} align="start" gap="8"
        width="100%" px="5" py="5">
        <Flex className="main-content-sidebar" direction="column" align="start" gap="1"
          style={{ minWidth: "144px" }}>
          <MenuItem
            flag="active"
            state={integrationsMenuSelection}
            onClick={handleIntegrationsMenuSelection}
            text="Connected"
            tooltip="View and manage your connected integrations"
            icon={<LinkIcon height={16} width={16} />}
          />
          <MenuItem
            flag="browse-all"
            state={integrationsMenuSelection}
            onClick={handleIntegrationsMenuSelection}
            text="Browse all"
            tooltip="Explore and connect new integrations to enhance your platform's capabilities"
            icon={<Square3Stack3DIcon height={16} width={16} />}
          />
        </Flex>
        <Flex style={{ alignSelf: "stretch", flex: "1 0 0", alignItems: "flex-start", minHeight: 0, overflow: "hidden" }}>
          <Outlet />
        </Flex>
      </Flex>
    </Flex>
  );
}
